import HbiImagemLoginClient from '@/api/SistemaDKP/sls-imagem-login.client';

const imagemLoginClient = new HbiImagemLoginClient();
export default {
  namespaced: true,
  state: () => ({
    copyCurrentImagemLogin: null,
    currentImagemLogin: {
      id: null,
      url: null,
      uuid_cliente: null,
      chave: null,
    },
    imagensLogin: [],
    filters: {
      page: 1,
      perPage: 10,
      sortBy: 'id',
      sortDesc: null,
    },
    isLoading: false,
  }),
  mutations: {
    setImagensLogin(state, imagensLogin) {
      state.imagensLogin = imagensLogin;
    },
    setFilters(state, payload) {
      state.filters = payload;
    },
    setOptionsMarcas(state, payload) {
      state.optionsMarcas = payload;
    },
    setIsLoading(state, payload) {
      state.isLoading = payload;
    },
    addOfUpdateImagemLogin(state, imagemLogin) {
      const index = state.imagensLogin.findIndex((i) => i.id === imagemLogin.id);
      if (index === -1) {
        state.imagensLogin.push(imagemLogin);
      } else {
        state.imagensLogin[index] = imagemLogin;
      }
    },
    setCurrentImagemLogin(state, imagemLogin) {
      state.copyCurrentImagemLogin = { ...imagemLogin };
      state.currentImagemLogin = {
        ...imagemLogin,
        url: null,
        chave: null,
        uuid_cliente: null,
      };
    },
    deleteImagemLogin(state, id) {
      const index = state.imagensLogin.findIndex((i) => i.id === id);
      state.imagensLogin.splice(index, 1);
    },
    resetCurrentImagemLogin(state) {
      state.currentImagemLogin = {
        id: null,
        url: null,
        uuid_cliente: null,
        chave: null,
      };
      state.copyCurrentImagemLogin = {
        id: null,
        url: null,
        uuid_cliente: null,
        chave: null,
      };
    },
  },
  getters: {
    getCurrentImagemLogin(state) {
      return state.currentImagemLogin;
    },
    getCopyCurrentImagemLogin(state) {
      return state.copyCurrentImagemLogin;
    },
    getFilters(state) {
      return state.filters;
    },
    getIsLoading(state) {
      return state.isLoading;
    },
    getIsAlteracao(state) {
      return JSON.stringify(state.currentImagemLogin) !== JSON.stringify(state.copyCurrentImagemLogin);
    },
  },
  actions: {
    async findAll(ctx, queryParams, options) {
      console.log('STORE');
      const { data, ...paginations } = await imagemLoginClient.getImagemLogin(queryParams);
      ctx.commit('setImagensLogin', data);
      ctx.commit('setFilters', {
        ...ctx.getters.getFilters,
        page: paginations.page,
        perPage: paginations.perPage,
      });
      return Promise.resolve({
        data,
        paginations,
      });
    },
  },
};
